import type { SyncStatus } from "@hq/client";
import { useSyncExternalStore } from "react";
import { useSyncEngine } from "./provider";

/** The engine's current status; re-renders on every change. */
export function useSyncStatus(): SyncStatus {
  const engine = useSyncEngine();
  return useSyncExternalStore(engine.subscribe, engine.getStatus, engine.getStatus);
}
